import _ from 'lodash'
import vm from '../main'
import { httpClient as http } from '../services'

const internals = {}

internals.addsecondaryTrip = secondaryTrip => {
  // primaryTrip = Object.assign({}, primaryTrip)
  const promises = []
  return http
    .post('/trip/secondary-trip/create', {
        cityId: secondaryTrip.cityId,
        tId: secondaryTrip.tId,
        SpDyId: secondaryTrip.SpDyId,
        driverId: secondaryTrip.driverId,
        vehicleId: secondaryTrip.vehicleId,
        tripStatus: secondaryTrip.tripStatus,
        startTime: secondaryTrip.startTime,
        endTime: secondaryTrip.endTime,
        endDate: secondaryTrip.endDate,
        scheduleTime: secondaryTrip.scheduleTime,
        collectionDataInfo: secondaryTrip.collectionDataInfo,

    })
    .then(result => {
        secondaryTrip = result.data
      return result
    })
    .catch(error => {
      console.error('secondaryTripService-error:\n', error)
      throw error
    })
}


internals.updateSecondaryTrip = secondaryTrip => {
  // primaryTrip = Object.assign({}, primaryTrip)
  const promises = []
  return http
    .put('/trip/secondary-trip/update', {
        tId: secondaryTrip.tId,
        SpDyId: secondaryTrip.SpDyId,
        driverId: secondaryTrip.driverId,
        vehicleId: secondaryTrip.vehicleId,
        tripStatus: secondaryTrip.tripStatus,
        startTime: secondaryTrip.startTime,
        endTime: secondaryTrip.endTime,
        endDate: secondaryTrip.endDate,
        scheduleTime: secondaryTrip.scheduleTime,
        collectionDataInfo: secondaryTrip.collectionDataInfo,
        _id: secondaryTrip._id,
    })
    .then(result => {
        secondaryTrip = result.data
      return result
    })
    .catch(error => {
      console.error('secondaryTripService-error:\n', error)
      throw error
    })
}


internals.getById = id => {
  return http
    .get(`/trip/secondary-trip/${id}`)
    .then(response => {        
      return response
    })
    .catch(error => {
      console.error('primaryTripService-error:\n', error)
      throw error
    })
}

internals.getWasteTransferredFromList = (id) => {
  return http
    .get(`/trip/secondary-trip/secondaryTrip-with-waste-collected-from-details/${id}`)
    .then(response => {        
      return response
    })
    .catch(error => {
      console.error('secondaryTripService-error:\n', error)
      throw error
    })
}

internals.getList = params => {
  let parameters = `?page=${params.page}&limit=${params.limit}`;
  if(params.cityIds){
    parameters += `&cityIds=${params.cityIds}`;
  }
  if(params.startLoc){
    parameters += `&startLoc=${params.startLoc}`;
  }
  if(params.endLoc ){
    parameters += `&endLoc =${params.endLoc }`;
  }
  if(params.startDate){
    parameters += `&startDate=${params.startDate}`;
    parameters += `&endDate=${params.endDate}`;
  }
  if(params.sortBy){
    parameters += `&sortBy=${params.sortBy}`;
    parameters += `&sortOrder=${params.sortOrder}`;
  }
  if(params.searchString){
    parameters += `&searchString=${params.searchString}`;
  }
  if(parameters.status){
    parameters += `&status=${params.status}`;
  }
  return http
    .get(`/trip/secondary-trip${parameters}`)
    .then(response => {        
      return response
    })
    .catch(error => {
      console.error('secondaryTripService-error:\n', error)
      throw error
    })
}


internals.getSegregationDumpyardList = Id => {
    return http
      .get(`/segregation-dumyard/list?cityId=${Id}`)
      .then(response => {        
        return response
      })
      .catch(error => {
        console.error('secondaryTripService-error:\n', error)
        throw error
      })
  }

internals.getTransportList = Id => {
    return http
      .get(`/transport/list?cityId=${Id}`)
      .then(response => {        
        return response
      })
      .catch(error => {
        console.error('secondaryTripService-error:\n', error)
        throw error
      })
  }

  internals.getListDate = params => {
    return http
      .get(`/trip/secondary-trip?limit=${params.limit}&page=${params.page}&endDate=${params.endDate}&startDate=${params.startDate}`)
      .then(response => {        
        return response
      })
      .catch(error => {
        console.error('primaryTripService-error:\n', error)
        throw error
      })
  }


export default internals



// WEBPACK FOOTER //
// ./src/services/secondaryTrip.service.js